module.exports = __webpack_public_path__ + "img/paytype2-icon.021516ba.png";